export default "__VITE_PUBLIC_ASSET__9018932f__"